import React, { Component } from "react";
import { Segment, Grid, Header, Container, Icon } from "semantic-ui-react";

export default class BodyContent extends Component {
  render() {
    return (
      <Segment inverted vertical style={{ padding: "1em 0em" }}>
        <Container>
          <Grid divided inverted stackable>
            <Grid.Row>
              <Grid.Column width={7}>
                <Header as="h4" inverted>
                  Connect with us on social media.
                </Header>
                <p>
                  <a
                    style={{ color: "white" }}
                    href="https://www.facebook.com/abundancebased/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon
                      name="facebook f"
                      size="big"
                      //link
                    />
                  </a>
                  <a
                    style={{ color: "white", paddingLeft: 15 }}
                    href="https://t.me/joinchat/J_BxahJ6O6AYyEa2mBg88A"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon name="telegram plane" size="big" />
                  </a>
                </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Footer.js